import React, { useEffect, useState } from 'react';
import { Button, Card } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { SearchInput } from "evergreen-ui";
import { Table } from 'antd';
import { TableExport } from "tableexport";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";

const columns = [
	{
		title: 'Key',
		dataIndex: 'key',
		key: 'key',
		sorter: (a, b) => a.key && a.key.localeCompare(b.key)
	},
	{
		title: 'Name',
		dataIndex: 'name',
		key: 'name',
		responsive: ["sm"],
		sorter: (a, b) => a.name && a.name.localeCompare(b.name)
	},
	{
		title: 'Grade',
		dataIndex: 'grade',
		key: 'grade',
		sorter: (a, b) => parseFloat(b.grade) - parseFloat(a.grade)
	},
	{
		title: 'Time',
		key: 'time',
		dataIndex: 'time',
		responsive: ["sm"],
		sorter: (a, b) => moment(a.time, "DD/MMM/YYYY HH:MM").diff(moment(b.time, "DD/MMM/YYYY HH:MM")),

	}
];

const moment = require("moment");
var db = getDatabase(Firebase);
const quizCompletions = (props) => {
	const [quizID, setQuizID] = useState(props?.quizID);
	const [eventsData, setEventsData] = useState([]);
	const [userArray] = useListVals(ref(db, "talmidsdb/users"));
	const [quizCompletions, loading] = useListVals(ref(db, "talmidsdb/quizCompletions"));
	const [dataArray, setDataArray] = useState([]);
	const [searchValue, setSearchValue] = useState();
	console.log(props);
	useEffect(() => {
		setQuizID(props?.quizID);
		if (quizCompletions) {
			var tempArray = [];
			var quizzes = quizCompletions.filter(x => x.quizID === props?.id);
			quizzes.map((item, index) => {
				tempArray.push({
					key: index + 1,
					grade: item.grade,
					name: userArray[userArray.findIndex(x => (x.id) === item.userID)] ?
						userArray[userArray.findIndex(x => (x.id) === item.userID)].firstname + " "
						+ userArray[userArray.findIndex(x => (x.id) === item.userID)].surname : "Unknown User",
					time: moment(item.timestamp, "YYYY-MM-DDTh:mm:ss").format("DD/MMM/YYYY HH:MM"),
				});
			});

			setDataArray([...tempArray]);
			setEventsData([...tempArray]);
		}

	}, [props?.quizID, quizCompletions, userArray]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ name, time }) => {
			name = name.toLowerCase();
			time = time.toLowerCase();
			return name.includes(searchText) || time.includes(searchText);
		});
		setEventsData(filteredEvents);
	};

	const exportXL = (title) => {
		var table = TableExport(document.getElementById("grades"), {
			filename: title,
			exportButtons: false,
			sheetname: title,
		});
		var exportData = table.getExportData();
		console.log(exportData);
		var csv = exportData.grades.csv;
		table.export2file(csv.data, csv.mimeType, csv.filename, csv.fileExtension, csv.merges, csv.RTL, csv.sheetname);

	}
	return (
		<div>
			<div className="font-Nunito">
				<div className="d-flex flex-row justify-content-end mr-3 p-2">
					<SearchInput placeholder="Filter through name or time" onChange={e => handleSearch(e.target.value)} value={searchValue} />
					<Button type="primary"
						onClick={() => {
							exportXL("quizCompletions");
						}} className="d-inline float-right mx-4">
						Print
					</Button>
				</div>
				<MDBRow className="w-100">
					<MDBCol md={12}>
						<Card>
							<Table className="custom-table" id="grades"
								loading={loading}
								style={{ overflow: "auto" }} columns={columns} dataSource={eventsData} />
						</Card>
					</MDBCol>
				</MDBRow>
			</div>
		</div>
	)

}

export default quizCompletions;
